import { render, staticRenderFns } from "./ModalContentMemberEdit.vue?vue&type=template&id=5137ab1c&scoped=true&"
import script from "./ModalContentMemberEdit.vue?vue&type=script&lang=js&"
export * from "./ModalContentMemberEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5137ab1c",
  null
  
)

export default component.exports